import { fabric } from 'fabric';
import DEFINE from '../define';
import ToolBase from '../basic';
import { focusStore } from '../../store/nowFocusStore';

export default class TriangleTool extends ToolBase {

    name = DEFINE.TOOLS.TRIANGLE_TOOL;

    originPosition = new fabric.Point(600, 550);

    // 三角形工具
    triangle_tool = null;

    //輸入參數
    value = null;

    constructor(parent) {
        super(parent);
    }

    create() {
        super.create();

        const self = this;

        this.originPosition.x = focusStore.mainBookPage.pagePercentPoint.x * this.parent.canvas.width;
        this.originPosition.y = focusStore.mainBookPage.pagePercentPoint.y * this.parent.canvas.height;

        let value = this.value;

        const radius = 100; //三角形大小半徑
        let rotate = 0;     //紀錄旋轉度數（若為垂直需要旋轉）

        //三點座標
        let pointArray = [];
        //紀錄三邊弧度
        let radianArray = [];

        if (value.type == "angle") {
            //三角形三個角度（）
            let triangleSide = {
                a: value.input.angleA,
                b: value.input.angleB,
                c: value.input.angleC
            };
            this.sortSide(triangleSide);

            //角度越大，對邊越長
            radianArray.push(triangleSide.a / 180 * Math.PI * 2);
            radianArray.push(triangleSide.b / 180 * Math.PI * 2);
            radianArray.push(triangleSide.c / 180 * Math.PI * 2);

        } else {
            //三角形三邊長
            let triangleSide = {
                a: value.input.lengthA,
                b: value.input.lengthB,
                c: value.input.lengthC
            };
            this.sortSide(triangleSide);

            let a = triangleSide.a;
            let b = triangleSide.b;
            let c = triangleSide.c;

            radianArray.push(2 * Math.acos((b ** 2 + c ** 2 - a ** 2) / (2 * b * c)));
            radianArray.push(2 * Math.acos((a ** 2 + c ** 2 - b ** 2) / (2 * a * c)));
            radianArray.push(2 * Math.acos((a ** 2 + b ** 2 - c ** 2) / (2 * a * b)));
        }

        radianArray[1] += radianArray[0];
        radianArray[2] += radianArray[1];

        for (let i = 0; i < radianArray.length; i++) {
            //計算新的x, y座標
            let x = radius * Math.cos(radianArray[i]);
            let y = radius * Math.sin(radianArray[i]);

            pointArray.push({ x: x, y: y });
        }

        //排序後最長邊固定為0,2
        //計算座標差
        let deltaX = pointArray[0].x - pointArray[2].x;
        let deltaY = pointArray[0].y - pointArray[2].y;

        //若y = 0則表示已是平行
        if (deltaY == 0) {
            rotate = 180;
        }
        //若x = 0則表示是垂直
        else if (deltaX == 0) {
            rotate = -90;
        } else {
            pointArray = this.rotateAngle(pointArray);
            rotate = 180;
        }

        self.triangle_tool = new fabric.Polygon(pointArray, {
            tag: DEFINE.TAG.TRIANGLE_TOOL + new Date().getTime(),
            toolType: self.name,
            angle: rotate,
            left: self.originPosition.x,
            top: self.originPosition.y,
            fill: DEFINE.COLOR.TRANSPARENT,
            stroke: DEFINE.COLOR.MATH_TOOL.BLACK_0_0_0,
            strokeWidth: 5,
            originX: "center",
            originY: "center",
            transparentCorners: false,
            cornerColor: DEFINE.COLOR.CORNER_COLOR,
            selectable: true,
        });

        self.setControls(self.triangle_tool);

        self.canvas.add(self.triangle_tool);
        self.canvas.renderAll();
    }

    setValue(value) {
        super.setValue(value);

        console.log(value);
        this.value = value;
    }

    recover(object) {
        let tag = object.tag;

        if (tag.includes(DEFINE.TAG.TRIANGLE_TOOL)) {
            this.triangle_tool = object;

            this.setControls(object);
        }
    }

    setControls(object) {
        object.set({
            hasBorders: false,
            controls: Object.assign(this.getBasicControls(), {
                mtr: this.getTouchRotateControl({
                    x: 0.5,
                    y: 0,
                    offsetX: 25,
                    offsetY: 0,
                }),
                deleteControl: this.getDeleteControl({
                    x: 0.5,
                    y: -0.5,
                    offsetX: 25,
                    offsetY: 0,
                }),
            })
        });
    }

    /**
     * 三角形工具專用，將三角形最長邊改為平行（重設座標）        
     * @param {*} pointArray 
     * @returns 
     */
    rotateAngle(pointArray) {
        //計算新index 2座標
        //計算距離
        let deltaX = pointArray[2].x - pointArray[0].x;
        let deltaY = pointArray[2].y - pointArray[0].y;
        let distance = Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));

        pointArray[2].x = pointArray[0].x + distance;
        pointArray[2].y = pointArray[0].y;
        //計算index 2座標角度以計算座標1
        //計算弧度
        let radian2 = Math.atan(deltaY / deltaX);
        //弧度轉角度
        let angle2 = radian2 * 180 / Math.PI;

        //計算新index 1座標
        //計算斜率
        deltaX = pointArray[1].x - pointArray[0].x;
        deltaY = pointArray[1].y - pointArray[0].y;
        //計算弧度
        let radian1 = Math.atan(deltaY / deltaX);
        //弧度轉角度
        let angle1 = radian1 * 180 / Math.PI;

        //計算新角度及弧度
        let angle = angle1 - angle2;
        let radian = angle / 180 * Math.PI;

        //新斜率
        let slope = Math.tan(radian);
        distance = Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));

        //以新斜率及距離求新座標
        deltaX = distance / Math.sqrt(Math.pow(slope, 2) + 1);
        deltaY = deltaX * slope;

        pointArray[1].x = pointArray[0].x + deltaX;
        pointArray[1].y = pointArray[0].y + deltaY;

        return pointArray;
    }

    /**
     * 將邊長排序，由長到短
     * @param {*} triangleSideObj 
     */
    sortSide(triangleSideObj) {
        if (triangleSideObj.a < triangleSideObj.b) {
            let t = triangleSideObj.a;
            triangleSideObj.a = triangleSideObj.b;
            triangleSideObj.b = t;
        }

        if (triangleSideObj.b < triangleSideObj.c) {
            let t = triangleSideObj.b;
            triangleSideObj.b = triangleSideObj.c;
            triangleSideObj.c = t;
        }

        if (triangleSideObj.a < triangleSideObj.b) {
            let t = triangleSideObj.a;
            triangleSideObj.a = triangleSideObj.b;
            triangleSideObj.b = t;
        }
    }
}